// Module
var code = `<mat-dialog-content>
    <div class="hoa-dialog__container">
        <div class="hoa-dialog__header">
            <h1>Network Connection Error</h1>
        </div>
        <div class="hoa-dialog__main">
            <p class="u-textCenter">Network connection lost</p>
            <p class="u-textCenter">Your network connection was lost. Would you like to retry the request?</p>
        </div>
        <div class="hoa-dialog__footer" ifOverFlowXClass="hoa-dialog__footer--overflowX">
            <!--<button class="Button Button&#45;&#45;link Button&#45;&#45;minWidth130" (click)="closeIt('Logout')">Logout</button>-->
            <button class="Button Button--link Button--minWidth130" (click)="closeIt(0)">No</button>
            <button class="Button Button--blue Button--minWidth130" (click)="closeIt('Retry')">Yes</button>
        </div>
    </div>
</mat-dialog-content>`;
// Exports
module.exports = code;